import { useEffect, useState, type RefObject } from "react";

export enum ViewportKind {
  MOBILE = "mobile",
  DESKTOP = "desktop",
}

export const useViewportKind = ({
  ref,
  breakpoint = 768,
}: {
  ref: RefObject<HTMLElement | null>;
  breakpoint?: number;
}) => {
  const [kind, setKind] = useState<ViewportKind | undefined>(undefined);

  useEffect(() => {
    const element = ref.current;
    if (!element || typeof ResizeObserver === "undefined") return;
    const check = () => {
      const width = element.getBoundingClientRect().width;
      if (width > 0) setKind(width < breakpoint ? ViewportKind.MOBILE : ViewportKind.DESKTOP);
    };
    check();
    const observer = new ResizeObserver(check);
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, breakpoint]);

  return kind;
};
